import React, { FunctionComponent } from "react";
import { SpinnerIcon } from "./SpinnerIcon";
import "./Spinner.css";

export interface SpinnerProps {
  /**
   * The variant of the spinner
   */
  variant?: "circle" | "q-logo";

  /**
   * Whether to show the loading text
   */
  showText?: boolean;

  /**
   * Optional CSS class name
   */
  className?: string;

  /**
   * Optional loading text
   */
  loadingText?: string;
}

export const Spinner: FunctionComponent<SpinnerProps> = ({
  variant = "circle",
  showText = false,
  className = "",
  loadingText = "Cargando",
}) => {
  const containerClasses = [
    "qida-spinner",
    `qida-spinner--${variant}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={containerClasses}>
      {variant === "circle" && (
        <div className="qida-spinner__circle">
          <div className="qida-spinner__circle-inner" />
        </div>
      )}

      {variant === "q-logo" && (
        <div className="qida-spinner__q-container">
          <div className="qida-spinner__q-wrapper">
            <SpinnerIcon
              color="var(--colors-primary-500)"
              width={35}
              height={38.4}
              className="qida-spinner__q-logo"
            />
          </div>
        </div>
      )}

      {showText && <div className="qida-spinner__text">{loadingText}</div>}
    </div>
  );
};

export default Spinner;
